import React, { Component } from "react";
import { connect } from "react-redux";

import RiskSelector from "@workerhome/components/Content/RiskSelector";
import { RiskWarningDialog } from "@workerhome/components/Dialogs";
import { selectRisk, toggleDialog } from "@workerhome/components/App/actions";
import { RiskListHeader } from "@common/styled/risk";
import { RiskSelectorListWrapper } from "./styled";

class RiskSelectorList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      riskDialog: {},
      appendixDialog: {}
    };
  }

  /**
   * Handle the risk selection changes to determine if risk has been indicated
   * @param  {object} event   Event object
   * @param  {string} value   New value from radio button
   * @param  {int}    riskIdx Index value of changed risk
   */
  onRadioChange = (event, value, riskIdx) => {
    const risk = this.props.children[riskIdx];

    // Determine if the selected value indicates a risk
    const isRisk = risk.whichIsRisk === value ? true : false;

    // Display a dialog if an elevated risk is selected
    if (risk.isElevated && isRisk) {
      this.toggleRiskWarningDialog(risk, riskIdx);
    }

    // Call the dispatch function to update the Redux state
    this.props.selectRisk(isRisk, this.props.stepsMeta.activeSubStep, riskIdx);
  };

  // Display a dialog if an elevated risk is indicated
  toggleRiskWarningDialog = (risk, riskIdx) => {
    const { section, stepsMeta } = this.props;

    // Set the elevated risk warning dialog content in (local state)
    this.setState({
      riskDialog: {
        key: risk.elevatedKey,
        riskIdx,
        title: section.subsections[stepsMeta.activeSubStep].subTitle,
        content: risk.elevatedContent,
        description: risk.elevatedDescription
      }
    });

    // Toggle the risk warning dialog
    this.props.toggleDialog("RiskWarning", true);
  };

  /**
   * Render the risk selector list items
   * @param  {array}  risks List of risks to render
   * @return {object}       Rendered RiskSelector components
   */
  renderRiskSelectors = risks => {
    return risks.map((risk, idx) => {
      // Create a unique React key for each risk selector list item
      const uniqueKey = `${this.props.sectionKey}_${idx}`;

      let selectedValue = "";

      // Determine which radio button should be selected based on the combination
      //  of whether a risk has been indicated and which answer indicates risk
      if (risk.isRisk != null) {
        if (risk.whichIsRisk === "y") {
          selectedValue = risk.isRisk ? "y" : "n";
        } else {
          selectedValue = risk.isRisk ? "n" : "y";
        }
      }

      return (
        <RiskSelector
          key={uniqueKey}
          riskIdx={idx}
          sectionKey={this.props.sectionKey}
          selectedValue={selectedValue}
          onChange={this.onRadioChange}
          toggleRiskWarningDialog={() =>
            this.toggleRiskWarningDialog(risk, idx)}
        >
          {risk}
        </RiskSelector>
      );
    });
  };

  render() {
    const risks = this.props.children;

    return (
      <RiskSelectorListWrapper>
        <RiskListHeader>Risk Factors</RiskListHeader>
        {this.renderRiskSelectors(risks)}
        <RiskWarningDialog dialog={this.state.riskDialog} />
      </RiskSelectorListWrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    section: state.workerHome.app,
    stepsMeta: state.workerHome.sidebar.stepsMeta
  };
};

const mapDispatchToProps = dispatch => {
  return {
    selectRisk: (selectedValue, subSectionIdx, riskIdx) =>
      dispatch(selectRisk(selectedValue, subSectionIdx, riskIdx)),
    toggleDialog: (dialog, isShown) => dispatch(toggleDialog(dialog, isShown))
  };
};

const RiskSelectorListContainer = connect(mapStateToProps, mapDispatchToProps)(
  RiskSelectorList
);
export default RiskSelectorListContainer;



// WEBPACK FOOTER //
// ./src/workerhome/components/Content/RiskSelectorList/RiskSelectorListContainer.jsx